import { render, staticRenderFns } from "./brand_sales_revenue.vue?vue&type=template&id=43ffcd94&scoped=true&"
import script from "./brand_sales_revenue.vue?vue&type=script&lang=js&"
export * from "./brand_sales_revenue.vue?vue&type=script&lang=js&"
import style0 from "./brand_sales_revenue.vue?vue&type=style&index=0&id=43ffcd94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffcd94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ffcd94')) {
      api.createRecord('43ffcd94', component.options)
    } else {
      api.reload('43ffcd94', component.options)
    }
    module.hot.accept("./brand_sales_revenue.vue?vue&type=template&id=43ffcd94&scoped=true&", function () {
      api.rerender('43ffcd94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/brand_sales_revenue.vue"
export default component.exports